import { EntityModel } from '@/interfaces'
import {
  ALL_PERMISSIONS_QUERY,
  CREATE_PERMISSION_MUTATION,
  DELETE_PERMISSION_MUTATION,
  FORCE_DELETE_PERMISSION_MUTATION,
  SINGLE_PERMISSION_QUERY,
  UPDATE_PERMISSION_MUTATION,
} from './graphql'

const rbacPermissionModel: EntityModel = {
  name: 'permission',
  namePlural: 'permissions',
  uniqueName: 'rbacPermission',
  uniqueNamePlural: 'rbacPermissions',
  path: 'iam/rbac/permission',
  baseUrl: '/iam/rbac/permissions',
  translationPrefix: 'entities:rbacPermission.',
  getDisplayName: (values: any) => {
    return values.path
  },
  gql: {
    getAll: ALL_PERMISSIONS_QUERY,
    getSingle: SINGLE_PERMISSION_QUERY,
    create: CREATE_PERMISSION_MUTATION,
    update: UPDATE_PERMISSION_MUTATION,
    delete: DELETE_PERMISSION_MUTATION,
    forceDelete: FORCE_DELETE_PERMISSION_MUTATION,
  },
  attributes: {
    path: {
      name: 'path',
      label: 'entities:rbacPermission.attributes.path.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    module: {
      name: 'module',
      label: 'entities:rbacPermission.attributes.module.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:rbacPermission.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default rbacPermissionModel
